
<div mat-dialog-content >
  <form #form="ngForm" (keydown.enter)="$event.preventDefault()">
    <mat-card class="box mt-3 py-4">
      <!-- Non ci sarà tabella delle risposte per elementi quantitativi -->
      @if (
        criterio.response &&
        getCriteriaService().criteriaIsQualitative(
        criterio.typology
        )
        ) {
        <div
          class="row"
          >
          <!-- Tabella Feedback-->
          @if (criterio.response.length > 0) {
            <div
              class="col-12 px-2"
              >
              <mat-table
                [dataSource]="criterio.response"
                class="table-primary"
                >
                <!-- Sentiment Column -->
                <ng-container matColumnDef="sentiment">
                  <mat-header-cell
                    *matHeaderCellDef
                    style="justify-content: center"
                    >{{ "generic.sentiment" | translate }}
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    style="justify-content: center"
                    >
                    @if (element.sentiment_score == 0) {
                      <mat-icon
                        aria-hidden="false"
                        >sentiment_neutral
                        </mat-icon
                        >
                      }
                      @if (element.sentiment_score > 0) {
                        <mat-icon
                          aria-hidden="false"
                          style="color: #00bc1d"
                          >sentiment_satisfied_alt
                          </mat-icon
                          >
                        }
                        @if (element.sentiment_score < 0) {
                          <mat-icon
                            aria-hidden="false"
                            style="color: #ff0000"
                            >sentiment_very_dissatisfied
                            </mat-icon
                            >
                          }
                        </mat-cell>
                      </ng-container>
                      <!-- Feedback Column -->
                      <ng-container matColumnDef="feedback">
                        <!-- <mat-header-cell *matHeaderCellDef style="flex: 0 0 50% !important">Feedback </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="flex: 0 0 50% !important"> {{element.feedback}} </mat-cell> -->
                        <mat-header-cell
                          *matHeaderCellDef
                          style="flex: 0 0 50% !important"
                          >{{
                          "generic.feedback" | translate
                          }}</mat-header-cell
                          >
                          <mat-cell
                            *matCellDef="let element"
                            style="flex: 0 0 50% !important"
                            >
                            {{ element.feedback }}
                          </mat-cell>
                        </ng-container>
                        <!-- True False Column -->
                        <ng-container matColumnDef="truefalse">
                          <mat-header-cell *matHeaderCellDef>{{
                            "generic.consent"
                            | translate
                          }}</mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-chip-list>
                              @if (
                                getResponsesTypeService().isConsensusAgree(
                                element.consent_value
                                )
                                ) {
                                <mat-chip
                                  selectable="false"
                                  style="
                                    justify-content: center;
                                    pointer-events: none;
                                    background-color: #00bc1d;
                                  "
                                  class="text-white"
                                  >{{
                                  "components.responses.consensus.agree" | translate
                                  }}</mat-chip
                                  >
                                }
                                @if (
                                  getResponsesTypeService().isConsensusDisagree(
                                  element.consent_value
                                  )
                                  ) {
                                  <mat-chip
                                    selectable="false"
                                  style="
                                    justify-content: center;
                                    pointer-events: none;
                                    background-color: #ff0000;
                                  "
                                    class="text-white"
                                    >{{
                                    "components.responses.consensus.disagree" | translate
                                    }}</mat-chip
                                    >
                                  }
                                  @if (
                                    getResponsesTypeService().isConsensusAbstained(
                                    element.consent_value
                                    )
                                    ) {
                                    <mat-chip
                                      selectable="false"
                                  style="
                                    justify-content: center;
                                    pointer-events: none;
                                    background-color: rgb(167, 167, 167);
                                  "
                                      class="text-white"
                                      >{{
                                      "generic.answers.abstained" | translate
                                      }}</mat-chip
                                      >
                                    }
                                  </mat-chip-list>
                                </mat-cell>
                              </ng-container>
                              <!-- Confidence Column -->
                              <ng-container matColumnDef="confidence">
                                <mat-header-cell
                                  *matHeaderCellDef
                                  style="justify-content: center"
                                  >{{
                                  "components.proposals.new-proposal.confidence"
                                  | translate
                                  }}</mat-header-cell
                                  >
                                  <mat-cell
                                    *matCellDef="let element"
                                    style="justify-content: center"
                                    >
                                    <mat-chip-list
                                      >
                                      <mat-chip>{{
                                        element.confidence
                                      }}</mat-chip>
                                      </mat-chip-list
                                      >
                                    </mat-cell>
                                  </ng-container>
                                  <!-- feedback selection Column -->
                                  <ng-container matColumnDef="select">
                                    <mat-header-cell
                                      *matHeaderCellDef
                                      style="justify-content: center"
                                      >
                                      {{'modal.modal-virtual-assistant.select-feedback' | translate }}
                                      </mat-header-cell
                                      >
                                      <mat-cell *matCellDef="let element;" style="justify-content: center">
                                        <mat-chip-list>
                                          <mat-chip>
                                            <input type="checkbox" [(ngModel)]="element.checked" name="feedback"/>
                                          </mat-chip>
                                        </mat-chip-list>
                                      </mat-cell>
                                    </ng-container>
                                    <mat-header-row
                                      *matHeaderRowDef="displayedColumns"
                                    ></mat-header-row>
                                    <mat-row
                                      *matRowDef="let row; columns: displayedColumns"
                                    ></mat-row>
                                  </mat-table>
                                </div>
                              }
                              <!-- Tabella attachment pubmed-->
                              @if (criterio.attachment_pubmed.length > 0) {
                                <div
                                  class="col-12 px-2"
                                  >
                                  <!-- <mat-table
                                  [dataSource]="criterio.attachment_pubmed"
                                  class="table-primary"
                                  >
                                  <ng-container matColumnDef="pubmed">
                                    <mat-header-cell
                                      *matHeaderCellDef
                                      style="justify-content: center"
                                      >{{ "components.proposals.new-proposal.evidences" | translate }}
                                    </mat-header-cell>
                                    <mat-cell
                                      *matCellDef="let element"
                                      style="justify-content: center"
                                      >
                                      <a [href]="element.link" target="_blank">
                                        {{element.title}}
                                      </a>
                                    </mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="select">
                                    <mat-header-cell
                                      *matHeaderCellDef
                                      style="justify-content: center"
                                      >
                                      {{'modal.modal-virtual-assistant.select-feedback' | translate }}
                                      </mat-header-cell
                                      >
                                      <mat-cell *matCellDef="let element;" style="justify-content: center">
                                        <mat-chip-list>
                                          <mat-chip>
                                            <input type="checkbox" [(ngModel)]="element.checked" name="feedback">
                                          </mat-chip>
                                        </mat-chip-list>
                                      </mat-cell>
                                    </ng-container>
                                    <mat-header-row
                                      *matHeaderRowDef="displayedColumnsPubmedAttachments"
                                    ></mat-header-row>
                                    <mat-row
                                      *matRowDef="let row; columns: displayedColumnsPubmedAttachments"
                                    ></mat-row>
                                  </mat-table> -->
                                </div>
                              }
                              <!-- Tabella attachment files-->
                              <!-- <div
                              class="col-12 px-2"
                              *ngIf="criterio.attachment_files.length > 0"
                              >
                              <mat-table
                                [dataSource]="criterio.attachment_files"
                                class="table-primary"
                                >
                                <ng-container matColumnDef="file">
                                  <mat-header-cell
                                    *matHeaderCellDef
                                    style="justify-content: center"
                                    >{{ "components.proposals.new-proposal.evidences" | translate }}
                                  </mat-header-cell>
                                  <mat-cell
                                    *matCellDef="let element"
                                    style="justify-content: center"
                                    >
                                    <a [href]="element.link" target="_blank">
                                      {{element.title}}
                                    </a>
                                  </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="select">
                                  <mat-header-cell
                                    *matHeaderCellDef
                                    style="justify-content: center"
                                    >
                                    {{'modal.modal-virtual-assistant.select-feedback' | translate }}
                                    </mat-header-cell
                                    >
                                    <mat-cell *matCellDef="let element;" style="justify-content: center">
                                      <mat-chip-list>
                                        <mat-chip>
                                          <input type="checkbox" [(ngModel)]="element.checked" name="feedback" />
                                        </mat-chip>
                                      </mat-chip-list>
                                    </mat-cell>
                                  </ng-container>
                                  <mat-header-row
                                    *matHeaderRowDef="displayedColumnsFileAttachments"
                                  ></mat-header-row>
                                  <mat-row
                                    *matRowDef="let row; columns: displayedColumnsFileAttachments"
                                  ></mat-row>
                                </mat-table>
                              </div> -->
                            </div>
                          }
                          @if (revisionEnabled) {
                            <mat-card-actions align="end">
                              @if (!loading) {
                                <button
                                  class=" action-button text-white"
                                  color="primary"
                                  matButton="filled"
                                  (click)="onSubmit(form, this.proposeRevision)"
                                  [disabled]="disableRewriteStatementButton"
                                  >
                                  Propose revision
                                </button>
                                <button
                                  class=" action-button text-white"
                                  color="primary"
                                  matButton="filled"
                                  (click)="onSubmit(form, this.rewriteStatement)"
                                  [disabled] = "disableRewriteStatementButton"
                                  >
                                  Rewrite statement
                                </button>
                                <!--          <button-->
                                <!--            class=" danger action-button text-white"-->
                                <!--            matButton="filled"-->
                                <!--            (click)="onSubmit(form, this.rewriteStatementBeforeAnswers)"-->
                                <!--          >-->
                                <!--            Rewrite statement before answer-->
                              <!--          </button>-->
                              <button  matButton="filled" color="primary"  class="action-button"
                                (click)="copyText(response)"
                                [disabled]="disabledCopyButton">
                                {{'generic.copy-text' | translate}}
                              </button>
                            } @else {
                              <mat-spinner diameter="40"></mat-spinner>
                            }
                          </mat-card-actions>
                        }

                      </mat-card>

                      @if (response) {
                        <div class="text-container" [innerHTML]="renderedHTML">
                          <!--      {{ response }}>-->
                        </div>
                      }

                    </form>
                  </div>
